import type { ReprocessingGrantStatus } from '../Generated/ReprocessingGrantStatus.ts'
import type { OrderState } from './OrderState.ts'

/**
 * A done order may be reset for reprocessing only by its lab, and only while spcfy has an open grant on it
 * (the backend refuses the reset otherwise and consumes the grant when it succeeds).
 */
export const canReprocessDoneOrder = (
  orderState: OrderState,
  grant: ReprocessingGrantStatus | null,
  userOrgId: string | undefined,
  labId: string | undefined
): boolean => orderState === 'DONE' && !!grant?.open && !!userOrgId && userOrgId === labId
